import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'
import IdentityFormFields from './IdentityFormFields'
import useIdentity from './useIdentity'
import { SDOutlineButton, SpacingWrapper } from '@/shared/theme/styled-components'

const IdentityModal = () => {
  const { t, hidden, isOpen, openModal, closeModal } = useIdentity()

  if (hidden) return null

  return (
    <SpacingWrapper $marginTop='1rem'>
      {/* @ts-ignore */}
      <SDOutlineButton onClick={openModal}>
        {t('subscriptionForm:identity_module.module_title')}
      </SDOutlineButton>
      <SDModal
        isOpen={isOpen}
        openHandler={closeModal}
        title={t('subscriptionForm:identity_module.module_title')}
        sections={<IdentityFormFields />}
      />
    </SpacingWrapper>
  )
}

export default IdentityModal
